import { defineStore } from "pinia";

// Define a type for your route (adjust based on what you're storing)
type RouteInfo = string; // or a more complex type if needed

export const useNavigationStore = defineStore("navigation", {
  state: (): {
    history: RouteInfo[];
    previousRoute: RouteInfo | null;
  } => ({
    history: [],
    previousRoute: null,
  }),
  actions: {
    addRoute(route: RouteInfo) {
      if (this.history[this.history.length - 1] !== route) {
        this.previousRoute = this.history.length
          ? this.history[this.history.length - 1]
          : null;
        this.history.push(route);
      }
      // Keep only last 20 routes
      if (this.history.length > 20) {
        this.history.shift();
      }
    },
    removeRouteFromHistory(targetPath: string) {
      this.history = this.history.filter((path) => path !== targetPath);
      if (this.previousRoute === targetPath) {
        this.previousRoute = this.history.length
          ? this.history[this.history.length - 1]
          : null;
      }
    },
    clearNavigationHistory() {
      this.history = [];
      this.previousRoute = null;
    },
  },
});
